import { makeAutoObservable } from 'mobx'
import customerStore from './CustomerStore'

class ContactModalStore {
  showModal = false
  private pendingAction: (() => void) | null = null

  constructor() {
    makeAutoObservable(this)
  }

  get needsContact(): boolean {
    return !customerStore.email || !customerStore.phone
  }

  show(pendingAction?: () => void) {
    if (this.needsContact) {
      this.pendingAction = pendingAction ?? null
      this.showModal = true
    } else {
      pendingAction?.()
    }
  }

  hide() {
    this.showModal = false
    const fn = this.pendingAction
    this.pendingAction = null
    fn?.()
  }
}

export default new ContactModalStore()
